import { useContext } from "react"
import { ParametrosDeliveryContext } from "./ParametrosDeliveryContext"

export function useParametrosDeliveryContext() {
    return useContext(ParametrosDeliveryContext)
}
